function blurHandler(event: FocusEvent): void {
  const input = event.target as HTMLInputElement
  input.value = input.value.trim()
}

const InputTrimDirective = {
  mounted(el: HTMLDivElement) {
    const input = el.querySelector('input')
    if (!input) return
    input.addEventListener('blur', blurHandler)
  },
  unmounted(el: HTMLDivElement) {
    const input = el.querySelector('input')
    if (!input) return
    input.removeEventListener('blur', blurHandler)
  }
}

export default InputTrimDirective